// SABERA: 商品ギャラリー (スワイプ + サムネイル + 矢印 + カウンター)。
// snippets/sabera-product-gallery.liquid とセットで使う。
document.querySelectorAll('[data-sabera-gallery]').forEach((gallery) => {
  const viewport = gallery.querySelector('[data-sabera-gallery-viewport]');
  const track = gallery.querySelector('[data-sabera-gallery-track]');
  const slides = Array.from(track?.querySelectorAll('[data-sabera-gallery-slide]') || []);
  const thumbs = Array.from(gallery.querySelectorAll('[data-sabera-gallery-thumb]'));
  const prevBtn = gallery.querySelector('[data-sabera-gallery-prev]');
  const nextBtn = gallery.querySelector('[data-sabera-gallery-next]');
  const currentEl = gallery.querySelector('[data-sabera-gallery-current]');
  const tagEl = gallery.querySelector('[data-sabera-gallery-tag-el]');
  if (!viewport || !track || slides.length === 0) return;

  const totalEl = gallery.querySelector('[data-sabera-gallery-total]');
  if (totalEl) totalEl.textContent = slides.length;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let index = 0;
  let settleTimer;
  let loopTimer;

  if (slides.length > 1) {
    const firstClone = slides[0].cloneNode(true);
    const lastClone = slides[slides.length - 1].cloneNode(true);
    firstClone.dataset.saberaGalleryClone = 'first';
    lastClone.dataset.saberaGalleryClone = 'last';
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    track.prepend(lastClone);
    track.append(firstClone);
  }

  const setSlideWidth = () => {
    gallery.style.setProperty('--sabera-gallery-slide-width', `${viewport.clientWidth}px`);
  };

  const physicalIndex = (logicalIndex) => slides.length > 1 ? logicalIndex + 1 : logicalIndex;

  const setScrollPosition = (logicalIndex, behavior = 'auto') => {
    viewport.scrollTo({
      left: physicalIndex(logicalIndex) * viewport.clientWidth,
      behavior,
    });
  };

  const update = (nextIndex, scrollThumb = true) => {
    index = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      slide.setAttribute('aria-hidden', String(i !== index));
    });
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === index);
      thumb.setAttribute('aria-pressed', String(i === index));
    });
    const thumb = thumbs[index];
    const thumbTrack = thumb?.parentElement;
    if (scrollThumb && thumbTrack && (thumb.offsetLeft < thumbTrack.scrollLeft || thumb.offsetLeft + thumb.offsetWidth > thumbTrack.scrollLeft + thumbTrack.clientWidth)) {
      thumbTrack.scrollTo({
        left: thumb.offsetLeft - (thumbTrack.clientWidth - thumb.offsetWidth) / 2,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    }
    if (currentEl) currentEl.textContent = index + 1;
    if (tagEl) {
      const tag = slides[index].dataset.saberaGalleryTag || '';
      tagEl.textContent = tag;
      tagEl.hidden = tag === '';
    }
  };

  const show = (nextIndex, behavior = reducedMotion ? 'auto' : 'smooth') => {
    const wrappedIndex = (nextIndex + slides.length) % slides.length;
    const isNextLoop = index === slides.length - 1 && wrappedIndex === 0;
    const isPrevLoop = index === 0 && wrappedIndex === slides.length - 1;
    update(wrappedIndex);
    window.clearTimeout(loopTimer);
    if (isNextLoop) {
      viewport.scrollTo({ left: (slides.length + 1) * viewport.clientWidth, behavior });
    } else if (isPrevLoop) {
      viewport.scrollTo({ left: 0, behavior });
    } else {
      setScrollPosition(wrappedIndex, behavior);
      return;
    }

    // 端の複製スライドまで1枚分だけ移動した後、同じ画像の本来の位置へ
    // アニメーションなしで戻す。これにより末尾と先頭を途切れず循環できる。
    loopTimer = window.setTimeout(() => {
      update(wrappedIndex);
      setScrollPosition(wrappedIndex);
    }, reducedMotion ? 0 : 450);
  };

  const settle = () => {
    const position = Math.round(viewport.scrollLeft / viewport.clientWidth);
    if (slides.length > 1 && position === 0) {
      update(slides.length - 1);
      setScrollPosition(slides.length - 1);
      return;
    }
    if (slides.length > 1 && position === slides.length + 1) {
      update(0);
      setScrollPosition(0);
      return;
    }
    update(slides.length > 1 ? position - 1 : position, false);
  };

  viewport.addEventListener('scroll', () => {
    window.clearTimeout(settleTimer);
    settleTimer = window.setTimeout(settle, 100);
  }, { passive: true });

  prevBtn?.addEventListener('click', () => show(index - 1));
  nextBtn?.addEventListener('click', () => show(index + 1));
  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => show(i));
    thumb.addEventListener('keydown', (event) => {
      const target = { ArrowLeft: i - 1, ArrowRight: i + 1, Home: 0, End: slides.length - 1 }[event.key];
      if (target === undefined) return;
      event.preventDefault();
      show(target);
      thumbs[index]?.focus({ preventScroll: true });
    });
  });

  const resizeObserver = new ResizeObserver(() => {
    setSlideWidth();
    setScrollPosition(index);
  });
  resizeObserver.observe(viewport);

  setSlideWidth();
  update(0);
  requestAnimationFrame(() => setScrollPosition(0));
});
